/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { createSelector } from 'reselect';
import {MFE_STATE} from "support/BrokerageMFEUtils";

export const getBrokerageState = (state) => state.brokerage;

export const getBrokerageSSOData = createSelector(
  getBrokerageState,
  (brokerageState) => {
    return brokerageState.sso || {};
  }
);

export const getFixedIncomeSSOData = createSelector(
  getBrokerageState,
  (brokerageState) => {
    return brokerageState.fixedIncomeSso || {};
  }
);

export const getBrokerageMFEState = createSelector(
  getBrokerageState,
  (brokerageState) => {
    return brokerageState?.brokerageMFEState || MFE_STATE.LOADING;
  }
);

export const getBrokerageMFELogin = createSelector(
  getBrokerageState,
  (brokerageState) => {
    return brokerageState?.brokerageMFELogin || false;
  }
);